import type { TFunction } from "i18next";
import type { TourStep } from "../TourProvider";
import { queryTourTarget } from "../utils/queryTourTarget";

/**
 * Setup / create tour for Add Property page.
 */
export const addPropertyTour = (t: TFunction): TourStep[] => [
  {
    title: t("Tour_Setup_AddProperty_Form_Title"),
    description: t("Tour_Setup_AddProperty_Form_Description"),
    target: () => queryTourTarget("add-property-form"),
    placement: "right",
  },
  {
    title: t("Tour_Setup_AddProperty_Submit_Title"),
    description: t("Tour_Setup_AddProperty_Submit_Description"),
    target: () => queryTourTarget("add-property-submit"),
    placement: "top",
  },
];
